import { DirectoryGroup } from "@p0security/shared/types/directory";
import { SnowflakeInstaller } from "components/Integrations/Snowflake/install/types";

import { snowflakeIamWriteInstaller } from "./iam-write";

export const snowflakeInstaller = (
  groups?: DirectoryGroup[]
): SnowflakeInstaller => ({
  base: {
    items: {},
  },
  "iam-write": snowflakeIamWriteInstaller(groups),
});
